import React from 'react';
import {isRelatedFieldKeyColumn} from '../../../_shared/GWTBridge/invoke/formTable';
import {
    ChooseDropdownContent,
    SearchDropdownContent,
    StatusCircle
} from '../../../components/Common/FieldSearch';
import {FieldSearchDropdownProps} from '../../../components/Common/FieldSearch/types/DropdownProps';
import {useCallback} from 'react';

export const DropdownContent = (props: FieldSearchDropdownProps) => {
    const {isLoading, isSearchable, hasStatus} = props;
    const statusRenderer = useCallback((status: string) => <StatusCircle status={status} />, []);

    return (
        <>
            {!isLoading && (
                <>
                    {isSearchable ? (
                        <SearchDropdownContent
                            isRelateKeyColumn={isRelatedFieldKeyColumn()}
                            {...props}
                        />
                    ) : (
                        <ChooseDropdownContent
                            {...props}
                            statusRenderer={hasStatus ? statusRenderer : undefined}
                        />
                    )}
                </>
            )}
        </>
    );
};
